import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarSetupRead } from "./solar-read-retry"
import type { SolarProposalExtendedWarrantiesDto } from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** The Protection Plans offered for the design, and the saved one. */
export default function useSolarProposalExtendedWarranties(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalExtendedWarrantiesDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.extendedWarranties(proposalId ?? ``),
    queryFn: () => solarProposalService.getExtendedWarranties(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarSetupRead,
  })
}
